module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMyAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjE5MjcgMC40VjguMjhIMjIuMTEyN1YxMy43MkgxNC4xOTI3VjIxLjZIOC43NTI2NlYxMy43MkgwLjg3MjY1NlY4LjI4SDguNzUyNjZWMC40SDE0LjE5MjdaIiBmaWxsPSIjQThCMkM4Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/RF_assets/icons/plus.svg
// module id = ZbUQ
// module chunks = 28